import type { IntegrationName } from "@tellescope/tanstack-query";
import { useTranslation } from "react-i18next";
import { StepWrapper } from "./StepWrapper";
import { Button, cn, DialogFooter } from "@tellescope/ui";
import { useAuth, useTwilioActionsQuery } from "@tellescope/tanstack-query";
import { TwilioPhoneNumbers } from "../../../TwilioPhoneNumbers";

export interface TwilioSetupStepProps {
  selectedIntegrationNames: IntegrationName[];
  onBack?: () => void | Promise<void>;
  onSkip?: () => void | Promise<void>;
  onContinue: () => void | Promise<void>;
}

export const TwilioSetupStep = ({ selectedIntegrationNames, onBack, onSkip, onContinue }: TwilioSetupStepProps) => {
  const { t } = useTranslation("onboarding");
  const { isAdmin } = useAuth();
  const { isLoading } = useTwilioActionsQuery();

  return (
    <>
      <StepWrapper
        selectedIntegrationNames={selectedIntegrationNames}
        highlightedIntegrations={["twilio"]}
        completedIntegrations={["healthie"]}
      >
        <div data-testid="onboarding-twilio-step" className="contents">
          <TwilioPhoneNumbers />
        </div>
      </StepWrapper>
      <DialogFooter
        className={cn(
          "bg-gray-50 flex items-center justify-end py-4 px-8",
          onBack && "justify-between sm:justify-between"
        )}
      >
        {!!onBack && (
          <Button variant="outline" onClick={onBack} data-testid="onboarding-step-back">
            {t("Back")}
          </Button>
        )}
        <div className="flex items-center justify-end gap-2">
          {!!onSkip && (
            <Button variant="outline" onClick={onSkip} disabled={!isAdmin} data-testid="onboarding-step-skip">
              {t("I'll do this later")}
            </Button>
          )}
          <Button data-testid="onboarding-step-complete" onClick={onContinue} disabled={!isAdmin || isLoading}>
            {t("Complete Setup")}
          </Button>
        </div>
      </DialogFooter>
    </>
  );
};
